/*
 * Revival sales rep mode.
 * A rep turns it on once per browser on /pages/sales-team (code checked there against the Sales rep metaobjects).
 * While it's on:
 *   - a "Rep mode" bar shows at the top of every page (only in that browser);
 *   - every cart gets these attributes, which land on the order (Additional details) for Flow, reports and Celigo:
 *       "Order source" = "Sales rep - phone", "Sales rep" = rep name, "_rep_code", "_rep_netsuite_id";
 *   - "Send cart to customer" builds a cart link the customer opens to check out themselves. The link carries the
 *     same attributes with "Order source" = "Sales rep - customer link".
 * Orders without these attributes were placed by the customer on their own (Flow marks them "Customer - web").
 */
(function () {
  if (window.__rvRep) return; window.__rvRep = true;
  var KEY = 'revival_rep';
  var CART_KEY = 'revival_rep_cart';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SRC_PHONE = 'Sales rep - phone', SRC_LINK = 'Sales rep - customer link';

  function get() { try { var r = JSON.parse(localStorage.getItem(KEY)); return r && r.code && r.name ? r : null; } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function cartToken() { var m = document.cookie.match(/(?:^|; )cart=([^;]+)/); return m ? m[1] : ''; }
  function attrs(rep, source) {
    return { 'Order source': rep ? source : '', 'Sales rep': rep ? rep.name : '', '_rep_code': rep ? rep.code : '', '_rep_netsuite_id': rep ? (rep.nsid || '') : '' };
  }
  function updateCart(a) {
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) });
  }
  // Write rep attributes once per cart (and again after cart changes), or clear them after Exit.
  function sync(force) {
    var rep = get(), token = cartToken();
    if (!token) return;
    var key = (rep ? rep.code : 'none') + '|' + token;
    var last = ss(CART_KEY);
    if (!force && last === key) return;
    if (!rep && (!last || last.indexOf('none|') === 0)) return;
    updateCart(attrs(rep, SRC_PHONE)).then(function (r) { if (r.ok) ss(CART_KEY, key); }).catch(function () {});
  }

  function set(rep) {
    try { if (rep) localStorage.setItem(KEY, JSON.stringify(rep)); else localStorage.removeItem(KEY); } catch (e) {}
    ss(CART_KEY, null);
    if (cartToken()) updateCart(attrs(rep, SRC_PHONE)).catch(function () {});
    render();
    try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(rep ? 'revival_rep_mode_on' : 'revival_rep_mode_off', {}); } catch (e) {}
  }

  // Cart link for the customer. Cart links can't carry line item properties (prescription pet/vet details) or
  // subscriptions, so those carts have to be checked out by the rep on the phone.
  function buildLink(email) {
    var rep = get();
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || !cart.items.length) return { error: 'The cart is empty. Add the customer’s products first.' };
      var blocked = cart.items.filter(function (i) {
        var props = i.properties || {};
        var visible = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' || /rx|pet|vet/i.test(k); });
        return i.selling_plan_allocation || visible.length;
      });
      if (blocked.length) return { error: 'This cart has prescription or subscription items (' + blocked.map(function (i) { return i.product_title; }).join(', ') + '). Those can’t go in a link: check out with the customer on the phone instead.' };
      var lines = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      var a = attrs(rep, SRC_LINK), q = [];
      Object.keys(a).forEach(function (k) { if (a[k]) q.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(a[k])); });
      if (email) q.push('checkout[email]=' + encodeURIComponent(email));
      return { url: location.origin + root.replace(/\/$/, '') + '/cart/' + lines + '?' + q.join('&'), count: cart.item_count, total: cart.total_price };
    });
  }

  function money(cents) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); } }

  function render() {
    var rep = get(), bar = document.getElementById('rv-repbar');
    document.documentElement.classList.toggle('rv-rep-on', !!rep);
    if (!rep) { if (bar) bar.remove(); return; }
    if (!bar) { bar = document.createElement('div'); bar.id = 'rv-repbar'; bar.className = 'rv-repbar'; document.body.insertBefore(bar, document.body.firstChild); }
    bar.innerHTML =
      '<div class="rv-repbar__row"><span class="rv-repbar__tag">Rep mode</span><strong>' + esc(rep.name) + '</strong>' +
      '<span class="rv-repbar__hint">Orders from this browser are credited to you.</span>' +
      '<button type="button" class="rv-repbar__btn" data-rv-rep-send>Send cart to customer</button>' +
      '<button type="button" class="rv-repbar__link" data-rv-rep-exit>Exit</button></div>' +
      '<div class="rv-repbar__panel" data-rv-rep-panel hidden>' +
      '<label>Customer email (optional, fills in checkout) <input type="email" data-rv-rep-email autocomplete="off"></label>' +
      '<button type="button" class="rv-repbar__btn" data-rv-rep-make>Create link</button>' +
      '<p class="rv-repbar__msg" data-rv-rep-msg></p>' +
      '<div class="rv-repbar__out" data-rv-rep-out hidden><input type="text" readonly data-rv-rep-url>' +
      '<button type="button" class="rv-repbar__btn" data-rv-rep-copy>Copy</button><a class="rv-repbar__btn" data-rv-rep-mail href="#">Email it</a></div></div>';
  }

  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null; if (!t) return;
    if (t.closest('[data-rv-rep-exit]')) { if (confirmExit()) set(null); return; }
    if (t.closest('[data-rv-rep-send]')) { var p = document.querySelector('[data-rv-rep-panel]'); if (p) p.hidden = !p.hidden; return; }
    if (t.closest('[data-rv-rep-make]')) {
      var msg = document.querySelector('[data-rv-rep-msg]'), out = document.querySelector('[data-rv-rep-out]');
      var email = (document.querySelector('[data-rv-rep-email]') || {}).value || '';
      msg.textContent = 'Building link…'; out.hidden = true;
      buildLink(email.trim()).then(function (r) {
        if (r.error) { msg.textContent = r.error; return; }
        msg.textContent = r.count + ' item' + (r.count === 1 ? '' : 's') + ', ' + money(r.total) + ' before shipping and tax. The customer pays in checkout; the order is credited to you.';
        document.querySelector('[data-rv-rep-url]').value = r.url;
        var rep = get();
        document.querySelector('[data-rv-rep-mail]').href = 'mailto:' + encodeURIComponent(email.trim()) + '?subject=' + encodeURIComponent('Your Revival Animal Health order') +
          '&body=' + encodeURIComponent('Here is the order we put together for you. Review it and check out here:\n\n' + r.url + '\n\nThank you,\n' + rep.name + '\nRevival Animal Health\n1.800.786.4751');
        out.hidden = false;
      }).catch(function () { msg.textContent = 'Could not read the cart. Reload the page and try again.'; });
      return;
    }
    if (t.closest('[data-rv-rep-copy]')) {
      var u = document.querySelector('[data-rv-rep-url]'); u.select();
      (navigator.clipboard ? navigator.clipboard.writeText(u.value) : Promise.reject()).catch(function () { document.execCommand('copy'); });
      t.closest('[data-rv-rep-copy]').textContent = 'Copied';
    }
  });
  function confirmExit() { return window.confirm ? window.confirm('Turn off rep mode in this browser? New orders here will no longer be credited to you.') : true; }

  window.RevivalRep = { get: get, set: set, sync: sync };
  function boot() { render(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Horizon fires the cart event before the add request finishes, so on a brand-new cart there is no cart yet when
  // it fires. Sync again once the request settles, and once more shortly after, so the first add is never missed.
  function onCartChange(e) {
    sync();
    var p = e && ((e.detail && e.detail.promise) || e.promise);
    if (p && typeof p.then === 'function') p.then(function () { sync(); }, function () {});
    setTimeout(function () { sync(); }, 1500);
    setTimeout(function () { sync(); }, 4000);
  }
  document.addEventListener('shopify:cart:lines-update', onCartChange);
  document.addEventListener('cart:update', onCartChange);
})();
